// extracted by mini-css-extract-plugin
export default {"appointmentListContentIcon":"AppointmentList-module__appointmentListContentIcon--RoS6T"};